<template>
		<div class="list--view">
            <div class="single--list-view single--list-view-employees">
                <vs-select
                    class="selectExample"
                    v-model="selectTypeRoles"
                    @input="statusSelected"
                >
                    <vs-select-item
                        :is-selected="item.isSelected"
                        :key="index"
                        :value="item.value"
                        :text="item.label"
                        v-for="(item,index) in optionsTypeRoles" />
                </vs-select>
            </div>

        </div>
</template>

<script>
    export default {
        mounted(){

            this.locationIndexOfFilterEvaluated = location.search.indexOf("filter_evaluated") >= 0;
            let href = /filter_evaluated=([^&]+)/.exec(location.href);
            if(href == null){
                return;
            }

            this.locationHrefFilterEvaluated = href[1];

            switch (this.locationHrefFilterEvaluated) {
                case "1":
                  this.selectTypeRoles = "actual";
                  break;
                case "0":
                  this.selectTypeRoles = "all";
                  break;
                case "-1":
                  this.selectTypeRoles = "hystorical";
                  break
            }

        },
        data () {
            return {
                locationIndexOfFilterEvaluated : null,
                locationHrefFilterEvaluated : null,
                selectedFilter : null,

                selectTypeRoles: "all",
                optionsTypeRoles:[
                    {value: 'all', label: this.__("misc.all"), isSelected: false },
                    {value: 'hystorical', label: this.__("misc.hystorical"), isSelected: false },
                    {value: 'actual', label: this.__("misc.actual"), isSelected: false },
                ],
            }
        },
        methods: {
            statusSelected(selectedOption, id) {
                if (selectedOption == "actual") {
                    location.href = app.__vue__.addParam("filter_evaluated", "1");
                } else if (selectedOption == "hystorical") {
                    location.href = app.__vue__.addParam("filter_evaluated", "-1");
                } else if (selectedOption == "all") {
                    location.href = app.__vue__.addParam("filter_evaluated", "0");
                }
            },
        },
    }
</script>
